<template>
  <my-dialog
    @hideMask="$emit('update:personnelDialogFlag', false)"
    :dialogFlag="personnelDialogFlag"
    width="660px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="dialog_container">
      <div class="dialog_container_header">
        <h3 class="header_title">{{ title }}</h3>
        <div class="close_btn" @click="$emit('update:personnelDialogFlag', false)">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <div class="dialog_container_body">
        <div class="form_item" v-if="personnelType !== 2">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>姓名</span>
          </div>
          <div class="form_item_body">
            <a-input
              v-model:value="userName"
              placeholder="请输入姓名"
              style="width: 280px; margin-left: 16px"
            ></a-input>
          </div>
        </div>
        <div class="form_item" v-else>
          <div class="form_item_title">
            <span class="star">*</span>
            <span>姓名</span>
          </div>
          <div class="form_item_body">
            <a-select
              show-search
              v-model="userNameSelect"
              placeholder="请输入姓名"
              style="width: 280px; margin-left: 16px"
              :default-active-first-option="false"
              :show-arrow="true"
              :filter-option="false"
              :not-found-content="null"
              :loading="userListLoading"
              @search="userListSearch"
              @change="userListChange"
              @popupScroll="getMore"
            >
              <a-select-option :value="item.userId" v-for="(item, index) in userList" :key="index">
                {{ `${item.username || '- -'}` }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item" v-if="personnelType === 1">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>角色</span>
          </div>
          <div class="form_item_body">
            <a-select
              :default-value="roleDefault"
              placeholder="请选择人员角色"
              style="width: 280px; margin-left: 16px"
              @change="handleRoleChange"
            >
              <a-select-option :value="item.value" v-for="item in roleOptions" :key="item.value">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item" v-if="!personnelType">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>学校</span>
          </div>
          <div class="form_item_body">
            <a-select
              :default-value="schoolCodeDefault"
              placeholder="请选择所属学校"
              style="width: 280px; margin-left: 16px"
              @change="handleSchoolChange"
            >
              <a-select-option :value="item.value" v-for="item in schoolList" :key="item.value">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item" v-if="personnelType === 1 && roleType !== 1">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>学校</span>
          </div>
          <div class="form_item_body">
            <a-select
              :default-value="schoolCodeListDefault"
              :value="schoolCodeList"
              mode="multiple"
              placeholder="请选择所属学校"
              style="width: 280px; margin-left: 16px"
              @change="handleSchoolListChange"
              :filterOption="filterOption"
            >
              <a-select-option :value="item.value" v-for="item in schoolList" :key="item.value">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>手机号</span>
          </div>
          <div class="form_item_body">
            <a-input v-model:value="phone" placeholder="请输入手机号" style="width: 280px; margin-left: 16px"></a-input>
          </div>
        </div>
      </div>
      <div class="dialog_container_footer">
        <div class="cancel_btn" @click="$emit('update:personnelDialogFlag', false)">取消</div>
        <div class="confirm_btn" @click="handleConfirm">确定</div>
      </div>
      <div class="loading_mask" v-if="dialogLoading">
        <a-spin />
      </div>
    </div>
  </my-dialog>
</template>

<script>
import { searchUserInfo } from '@/server/api/courseManage'
import { checkRes } from '@/utils/tool'
export default {
  name: 'PersonnelDialog',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data() {
    return {
      dialogLoading: false,
      userName: undefined,
      roleOptions: [],
      roleType: '',
      schoolList: [],
      schoolCode: '',
      schoolCodeList: [],
      phone: '',
      roleDefault: undefined,
      schoolCodeDefault: undefined,
      schoolCodeListDefault: undefined,
      userListLoading: false,
      userListRt: {},
      userListPageNum: 1,
      userListPageSize: 20,
      userList: [],
      userNameSelect: undefined,
      userSelected: null
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    personnelType: {
      type: Number | String,
      default: ''
    },
    roleOptionsFromFather: {
      type: Array,
      default: []
    },
    schoolListFromFather: {
      type: Array,
      default: []
    },
    personnelDialogFlag: {
      type: Boolean,
      default: false
    },
    rowDetail: {
      type: Object,
      default: {}
    }
  },
  watch: {
    personnelDialogFlag: function (newVal) {
      if (!newVal) {
        this.resetForm()
        return
      }
      this.roleOptions = [
        ...this.roleOptionsFromFather
        // {
        //   title: '超级管理员',
        //   value: 1
        // },
        // {
        //   title: '管理员',
        //   value: 2
        // }
        // {
        //   title: '用户',
        //   value: 3
        // }
      ]
      this.schoolList = [...this.schoolListFromFather]
      if (Object.keys(this.rowDetail).length) {
        this.userName = this.rowDetail.userName
        this.userNameSelect = this.rowDetail.userId
        this.roleType = this.rowDetail.roleType
        this.schoolCode = this.rowDetail.schoolCode
        this.schoolCodeList = this.rowDetail.schoolCodeList
        this.phone = this.rowDetail.phone
        this.roleDefault = this.rowDetail.roleType
        this.schoolCodeDefault = this.rowDetail.schoolCode
        this.schoolCodeListDefault = this.rowDetail.schoolCodeList
      }
    }
  },
  methods: {
    resetForm() {
      this.userName = undefined
      this.userNameSelect = undefined
      this.roleType = ''
      this.schoolCode = ''
      this.schoolCodeList = []
      this.phone = ''
      this.roleDefault = undefined
      this.schoolCodeDefault = undefined
      this.schoolCodeListDefault = undefined
    },
    async handleConfirm() {
      try {
        if (!this.userName) return this.$message.error('请输入姓名')
        if (this.personnelType === 1 && this.roleType === '') return this.$message.error('请选择角色')
        if (!this.personnelType && !this.schoolCode) return this.$message.error('请选择所属学校')
        if (this.personnelType === 1 && !(this.schoolCodeList || []).length)
          return this.$message.error('请选择所属学校')
        if (!this.phone) return this.$message.error('请输入手机号')
        const params = {
          userName: this.userName,
          phone: this.phone
        }
        let apiName = ''
        let typeName = ''
        if (!this.personnelType) {
          apiName = 'userAdd'
          typeName = '添加用户'
          Object.assign(params, {
            schoolCode: this.schoolCode
          })
        }
        if (this.personnelType === 1) {
          apiName = 'adminAdd'
          typeName = '添加管理员'
          Object.assign(params, {
            schoolCodeList: this.schoolCodeList,
            roleType: this.roleType
          })
        }
        if (this.personnelType === 2) {
          apiName = 'assistantAdd'
          typeName = '添加助教'
          if (this.userSelected) {
            const { userId } = this.userSelected
            Object.assign(params, {
              userId
            })
          }
        }
        if (Object.keys(this.rowDetail).length) {
          Object.assign(params, {
            userId: this.rowDetail.userId
          })
          if (!this.personnelType) {
            apiName = 'userEdit'
            typeName = '编辑用户'
          }
          if (this.personnelType === 1) {
            apiName = 'adminEdit'
            typeName = '编辑管理员'
          }
          if (this.personnelType === 2) {
            apiName = 'assistantEdit'
            typeName = '编辑助教'
          }
        }
        this.dialogLoading = true
        const result = await this.$http[apiName](params)
        this.dialogLoading = false
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : `${typeName}失败`)
        this.$message.success(`${typeName}成功`)
        this.resetForm()
        this.$emit('update:personnelDialogFlag', false)
        this.$emit('getPersonnelList')
      } catch (err) {
        console.log(err)
      }
    },
    handleSchoolChange(value) {
      this.schoolCode = value
    },
    handleSchoolListChange(value) {
      this.schoolCodeList = value
    },
    handleRoleChange(value) {
      this.roleType = value
      if (this.roleType === 1) {
        this.schoolCodeList = this.schoolList.map((item) => item.value)
      } else {
        this.schoolCodeList = []
        this.schoolCodeListDefault = undefined
      }
    },
    async getUserList(keywords) {
      const self = this
      this.userListLoading = true
      const res = await searchUserInfo({
        keywords,
        pageSize: this.userListPageSize,
        pageNum: this.userListPageNum
      })
      this.userListLoading = false
      checkRes({
        res,
        success(data) {
          self.userListRt = data
          if (self.userListPageNum > 1) {
            self.userList = [...self.userList, ...data.list]
          } else {
            self.userList = data.list
          }
        },
        failed(err) {
          console.log(err)
        }
      })
    },
    userListSearch(keywords) {
      this.userListPageNum = 1
      this.getUserList(keywords)
    },
    userListChange(value) {
      this.userSelected = this.userList.find((item) => item.userId === value)
      if (this.userSelected) {
        const { phone, username } = this.userSelected
        this.phone = phone
        this.userName = username
      }
    },
    getMore(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target
      const { userListLoading, userListPageSize, userListPageNum, userListRt } = this
      if (userListLoading) return
      if (scrollHeight - scrollTop < clientHeight + 20) {
        if (userListPageNum * userListPageSize < userListRt.totalCount) {
          this.userListPageNum = userListPageNum + 1
          this.getUserList()
        }
      }
    },
    filterOption(value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0
    }
  },
  mounted() {
    this.userListSearch('')
  }
}
</script>

<style lang="scss" scoped>
.dialog_container {
  position: relative;
  .dialog_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #eaeaea;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .dialog_container_body {
    width: 100%;
    min-height: 400px;
    max-height: calc(100vh - 160px);
    padding: 15px;
    text-align: center;
    overflow-y: scroll;
    .form_item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .form_item_title {
        width: 70px;
        text-align: right;
        .star {
          color: #ff8786;
          margin-right: 5px;
        }
      }
      .form_item_body {
      }
    }
  }
  .dialog_container_footer {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border-top: 1px solid #eaeaea;
    display: flex;
    justify-content: center;
    .cancel_btn,
    .confirm_btn {
      width: 104px;
      height: 38px;
      border-radius: 5px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      box-shadow: 0 0 5px #f5f5f5;
      letter-spacing: 1px;
    }
    .cancel_btn {
      border: 1px solid #5f60d3;
      color: #5f60d3;
      background-color: #fff;
      margin-right: 16px;
      &:hover {
        background-color: #f5f5f5;
      }
      &:active {
        background-color: #fff;
      }
    }
    .confirm_btn {
      background-color: #5f60d3;
      color: #fff;
      &:hover {
        background-color: #4c4da9;
      }
      &:active {
        background-color: #5f60d3;
      }
    }
  }
}
.loading_mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}
</style>
